<script setup lang="ts">
import type { Component } from 'vue';
import { DropdownMenuItem } from 'reka-ui';

withDefaults(
    defineProps<{
        label?: string;
        addon?: string;
        icon?: Component;
        avatarUrl?: string;
        unstyled?: boolean;
        disabled?: boolean;
    }>(),
    {
        unstyled: false,
        disabled: false,
    },
);

defineEmits<{
    select: [event: Event];
}>();
</script>

<template>
    <DropdownMenuItem
        :disabled="disabled"
        :class="[
            unstyled ? '' : (
                'flex cursor-pointer items-center rounded px-3 py-2 text-sm text-muval-gray-1 outline-none transition-colors hover:bg-muval-gray-6 data-[highlighted]:bg-muval-gray-6'
            ),
            disabled && 'cursor-not-allowed opacity-50',
        ]"
        @select="$emit('select', $event)"
    >
        <template v-if="unstyled">
            <slot />
        </template>
        <template v-else>
            <slot name="icon">
                <component
                    :is="icon"
                    v-if="icon"
                    class="mr-2 size-5 shrink-0 text-muval-gray-2"
                />
                <img
                    v-else-if="avatarUrl"
                    :src="avatarUrl"
                    class="mr-2 size-5 shrink-0 rounded-full object-cover"
                />
            </slot>

            <span
                v-if="label"
                class="flex-1 truncate"
                >{{ label }}</span
            >
            <slot v-else />

            <slot name="addon">
                <span
                    v-if="addon"
                    class="ml-auto pl-2 text-xs text-muval-gray-3"
                >
                    {{ addon }}
                </span>
            </slot>
        </template>
    </DropdownMenuItem>
</template>
